<template>
    <div>                    <!-- Modal Component -->
                    <b-modal id="modal_form"
                         ref="modal_form"
                         size="lg"
                         :title="modal_titulo"
                         :ok-title="modal_botao"
                         close-title="Fechar"
                         v-model="showModal"
                         :ok-disabled=form.errors.any()
                         @ok="handleOk">
                    <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                        <b-container fluid class="p-a-0">
                            <div>
                            <b-row>
                                <b-col>
                                        <label>Descrição* <span v-b-tooltip title="Descrição para identificar o pedido" placement="top">[?]</span></label>
                                        <b-form-input type="text"
                                                    placeholder="Descrição"
                                                    v-model="form.descr"
                                                    name="descr"
                                                    >
                                        </b-form-input>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                                 </b-col>
                                  <b-col class="p-a-0">
                                          <label></label>
                                          <b-form-datepicker
                                                    locale="pt-br" 
                                                    placeholder="Data do Pedido" 
                                                    reset-button
                                                    v-model="form.dt_pedido" 
                                                    class="form-control" 
                                                    :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                                                    </b-form-datepicker>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('dt_pedido')" v-if="form.errors.has('dt_pedido')"></b-form-feedback>
                                  </b-col>
                                  <b-col >
                                      <label>Prod. predominante* <span v-b-tooltip title="Produto predominante utilizado para gerar o DOC" placement="top">[?]</span></label>
                                      <b-form-input type="text"
                                                  placeholder="Produto Predominante"
                                                  v-model="form.produto_predominante"
                                                  name="produto_predominante"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('produto_predominante')" v-if="form.errors.has('produto_predominante')"></b-form-feedback>
                                  </b-col>
                                  <b-col class="p-a-0">
                                     <label>Modal* <span v-b-tooltip title="Modal a ser utilizado para gerar o DOC" placement="top">[?]</span></label>
                                         <multiselect v-model="form.bmodal"
                                         :options="optionsBModal"
                                         track-by="value"
                                         label="label"
                                         :hide-selected="true"
                                         placeholder="Selecione"
                                         tag-placeholder=""
                                         select-label=""
                                         selected-label="Selecionado"
                                         deselect-label="Remover"
                                         ></multiselect>
                                         <b-form-feedback class="text-danger" v-text="form.errors.get('bmodal.value')" v-if="form.errors.has('bmodal.value')"></b-form-feedback>
                                  </b-col>
                                  <b-col>
                                      <label>CFOP <span v-b-tooltip title="CFOP utilizado para gerar o CTE, não obrigatório pois pode modificar no momento que gerar o CTE" placement="top">[?]</span></label>
                                      <multiselect v-model="form.cfop"
                                      :options="optionsCfop"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('cfop.value')" v-if="form.errors.has('cfop.value')"></b-form-feedback>
                                  </b-col>
                                  <b-col class="p-l-0">
                                      <label>CST <span v-b-tooltip title="CST utilizado para gerar o CTE, não obrigatório pois pode modificar no momento que gerar o CTE" placement="top">[?]</span></label>
                                      <multiselect v-model="form.cst"
                                      :options="optionsParamCst"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('cst.value')" v-if="form.errors.has('cst.value')"></b-form-feedback>
                                  </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                  <label>Município Início* <span v-b-tooltip title="Municipio de inicio da prestação utilizado para selecionar a alíquota" placement="top">[?]</span></label>
                                  <multiselect v-model="form.municipio_ini"
                                  :options="optionsMunicipioIni"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Selecione"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_ini.value')" v-if="form.errors.has('municipio_ini.value')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-a-0">
                                    <label>Município Fim* <span v-b-tooltip title="Municipio de fim da prestação utilizado para selecionar a alíquota" placement="top">[?]</span></label>
                                        <multiselect v-model="form.municipio_fim"
                                        :options="optionsMunicipioFim"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Selecione"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        ></multiselect>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_fim.value')" v-if="form.errors.has('municipio_fim.value')"></b-form-feedback>
                                </b-col>
                                <b-col>
                                  <label>Tipo Pedido* <span v-b-tooltip title="Indica o tipo do pedido ( Somente lotação suportado no momento )" placement="top">[?]</span></label>
                                  <multiselect v-model="form.tp_pedido"
                                  :options="optionsLivTpPedido"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Selecione"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('tp_pedido.value')" v-if="form.errors.has('tp_pedido.value')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-a-0">
                                    <label>Tipo Serviço* <span v-b-tooltip title="Tipo do serviço a ser executado" placement="top">[?]</span></label>
                                    <multiselect v-model="form.tp_servico"
                                    :options="optionsLivTpServico"
                                    track-by="value"
                                    label="label"
                                    :hide-selected="true"
                                    placeholder="Selecione"
                                    tag-placeholder="Selecionar"
                                    select-label="Selecionar"
                                    selected-label="Selecionado"
                                    deselect-label="Remover"
                                    ></multiselect>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('tp_servico.value')" v-if="form.errors.has('tp_servico.value')"></b-form-feedback>
                                </b-col>
                                <b-col>
                                    <label>Tipo Carga* <span v-b-tooltip title="Tipo da carga que será transportada" placement="top">[?]</span></label>
                                    <multiselect v-model="form.tp_carga"
                                    :options="optionsLivTpCarga"
                                    track-by="value"
                                    label="label"
                                    :hide-selected="true"
                                    placeholder="Selecione"
                                    tag-placeholder="Selecionar"
                                    select-label="Selecionar"
                                    selected-label="Selecionado"
                                    deselect-label="Remover"
                                    ></multiselect>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('tp_carga.value')" v-if="form.errors.has('tp_carga.value')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-l-0">
                                    <label>Tipo Fronteira* <span v-b-tooltip title="Indica se será gerado CTE ( Nacional )ou documento diferente ( Internacional, BL por exemplo )" placement="top">[?]</span></label>
                                    <multiselect v-model="form.tp_fronteira"
                                    :options="optionsLivTpFronteira"
                                    track-by="value"
                                    label="label"
                                    :hide-selected="true"
                                    placeholder="Selecione"
                                    tag-placeholder="Selecionar"
                                    select-label="Selecionar"
                                    selected-label="Selecionado"
                                    deselect-label="Remover"
                                    ></multiselect>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('tp_fronteira.value')" v-if="form.errors.has('tp_fronteira.value')"></b-form-feedback>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                  <label>% Advalorem Receita <span v-b-tooltip title="Percentual utilizado para calculo de ADValorem" placement="top">[?]</span></label>
                                  <b-form-input type="text"
                                              placeholder="% Advalorem Receita"
                                              v-money="aliquota"
                                              v-model="form.percentual_advalorem"
                                              name="percentual_advalorem"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('percentual_advalorem')" v-if="form.errors.has('percentual_advalorem')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-l-0">
                                  <label>Valor Advalorem* <span v-b-tooltip title="Indica o valor da NF a ser utilizado para calculo do ADValorem" placement="top">[?]</span> </label>
                                  <multiselect v-model="form.tp_valor_advalorem"
                                  :options="optionsLivTpValorAdvalorem"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Selecione"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('tp_valor_advalorem.value')" v-if="form.errors.has('tp_valor_advalorem.value')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-l-0">
                                  <label>Valor Carga* <span v-b-tooltip title="Indica o valor da NF a ser utilizado no campo Valor da Carga do CTE" placement="top">[?]</span></label>
                                  <multiselect v-model="form.tp_valor_carga"
                                  :options="optionsLivTpValorCarga"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Selecione"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('tp_valor_carga.value')" v-if="form.errors.has('tp_valor_carga.value')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-a-0">
                                  <label>Advalorem no C.Frete* <span v-b-tooltip title="Indica se o advalorem será somado a um componente de frete ou terá uma linha destacada no CTE" placement="top">[?]</span></label>
                                  <multiselect v-model="form.exibe_advalorem_cfrete"
                                  :options="optionsLivAdvalorem"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Selecione"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('exibe_advalorem_cfrete.value')" v-if="form.errors.has('exibe_advalorem_cfrete.value')"></b-form-feedback>
                                </b-col>
                                <b-col>
                                  <label>Permite Adicionar UC* <span v-b-tooltip title="Indica se poderá ser adicionado novas unidades de carga para o pedido, possibilitando novas emissões" placement="top">[?]</span></label>
                                  <multiselect v-model="form.permite_adicionar_uc"
                                  :options="optionsLivAddUc"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Selecione"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('permite_adicionar_uc.value')" v-if="form.errors.has('permite_adicionar_uc.value')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-l-0">
                                  <label>Imposto Incluso* <span v-b-tooltip title="Indica se os valores inseridos já possuem imposto incluso ( Somente SIM habilitado no momento )" placement="top">[?]</span></label>
                                  <multiselect v-model="form.imposto_incluso"
                                  :options="optionsLivImpostoIncluso"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Selecione"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('imposto_incluso.value')" v-if="form.errors.has('imposto_incluso.value')"></b-form-feedback>
                                </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                  <label>Custo Receita* <span v-b-tooltip title="Indica em qual custo o valor de receita será inserido" placement="top">[?]</span></label>
                                  <multiselect v-model="form.custo_receita"
                                  :options="optionsCusto"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Selecione"
                                  tag-placeholder=""
                                  select-label=""
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('custo_receita.value')" v-if="form.errors.has('custo_receita.value')"></b-form-feedback>
                              </b-col>
                              <b-col class="p-a-0">
                                  <label>Valor Total Despesa</label>
                                  <b-form-input type="text"
                                              placeholder="Despesa"
                                              v-model.lazy="valor_total_despesa"

                                              readonly>
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('despesa')" v-if="form.errors.has('despesa')"></b-form-feedback>
                              </b-col>
                              <b-col>
                                   <label>Valor Total Receita</label>
                                   <b-form-input type="text"
                                               placeholder="Receita"
                                               v-model.lazy="form.valor_total_receita"

                                               readonly>
                                   </b-form-input>
                                   <b-form-feedback class="text-danger" v-text="form.errors.get('receita')" v-if="form.errors.has('receita')"></b-form-feedback>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                  <label>Observação do pedido <span v-b-tooltip title="Observação interna para o pedido" placement="top">[?]</span></label>
                                  <b-form-textarea name="obs"
                                                   v-model="form.obs"
                                                   placeholder="Observação"
                                                   :rows="3"
                                                   :max-rows="6">
                                  </b-form-textarea>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                              </b-col>
                              <b-col class="p-a-0">
                                  <label>Observação CTE <span v-b-tooltip title="Observação utilizada no CTE, permite adicionar as tags predefinidas. Tags disponíveis: #num_pedido = Número do pedido, #container = Número do container, #lacre = Número do lacre, #peso_bruto = Peso bruto das notas fiscais, #advalorem_percentual = Valor do percentual de Advalorem" placement="top">[?]</span></label>
                                  <b-form-textarea name="obs_cte"
                                                   v-model="form.obs_cte"
                                                   placeholder="Observação CTE"
                                                   :rows="3"
                                                   :max-rows="6">
                                  </b-form-textarea>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('obs_cte')" v-if="form.errors.has('obs_cte')"></b-form-feedback>
                              </b-col>
                              <b-col>
                                  <label>Observação CTE Fiscal <span v-b-tooltip title="Observação fiscal utilizada no CTE, permite adicionar as tags predefinidas. Tags disponíveis: #num_pedido = Número do pedido, #container = Número do container, #lacre = Número do lacre, #peso_bruto = Peso bruto das notas fiscais, #advalorem_percentual = Valor do percentual de Advalorem" placement="top">[?]</span></label>
                                  <b-form-textarea name="obs_cte_fiscal"
                                                   v-model="form.obs_cte_fiscal"
                                                   placeholder="Observação CTE Fiscal"
                                                   :rows="3"
                                                   :max-rows="6">
                                  </b-form-textarea>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('obs_cte_fiscal')" v-if="form.errors.has('obs_cte_fiscal')"></b-form-feedback>
                              </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="3">
                                    <label>Qtde Unidade Carga*<span v-b-tooltip title="Quantidade de unidades de carga que serão geradas, com máximo de 200" placement="top">[?]</span></label>
                                    <b-form-input type="text"
                                                placeholder="Quantidade"
                                                v-model="form.qtde_uc"
                                                >
                                    </b-form-input>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('qtde_uc')" v-if="form.errors.has('qtde_uc')"></b-form-feedback>
                                </b-col>
                                <b-col cols="6" class="p-a-0" v-if="this.modal_acao=='i'">
                                  <label>Tomador*</label>
                                  <multiselect v-model="form.tomador"
                                  :options-limit="300"
                                  :limit="2"
                                  :limit-text="limitText"
                                  :options="optionsTomador"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  :searchable="true"
                                  :loading="isLoadingTom"
                                  @search-change="listaClientesTomador"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('tomador.value')" v-if="form.errors.has('tomador.value')"></b-form-feedback>
                                </b-col>
                                <b-col cols="3">
                                    <label>Tomador do CTE*</label>
                                    <multiselect v-model="form.pedido_tomador"
                                    :options="optionsPedidoTomador"
                                    track-by="value"
                                    label="label"
                                    :hide-selected="true"
                                    placeholder="Selecione"
                                    tag-placeholder="Selecionar"
                                    select-label="Selecionar"
                                    selected-label="Selecionado"
                                    deselect-label="Remover"
                                    ></multiselect>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('pedido_tomador.value')" v-if="form.errors.has('pedido_tomador.value')"></b-form-feedback>
                                </b-col>
                            </b-row>
                          </div>
                        </b-container><br>
                        <b-container fluid class="p-a-0">
                           <b-row>
                               <b-col>
                                   <b-tabs>
                                     <b-tab title="Trecho" active>
                                        <table class="table-striped">
                                           <tbody v-for="(row, index) in trecho">
                                              <tr :class="classSubtrecho(row.subtrecho)">
                                                 <th style="width: 10%">Principal / Ordem* / Advalorem<span v-b-tooltip title="Trecho principal do transporte ( Deve ter ao menos 1). A ordem dos transportes / serviços a serem realizados. Advalorem a ser pago para o prestado de serviço" placement="top">[?]</span></th>
                                                 <th style="width: 10%">Operação * <span v-b-tooltip title="Serviços são como OVA, DESOVA, etc, operação de transporte conta municipio de inicio e fim" placement="top">[?]</span></th>
                                                 <th style="width: 10%">Modal * <span v-b-tooltip title="Modal do trecho, caso seja multimodal, novas opções serão disponibilizadas" placement="top">[?]</span></th>
                                                 <th style="width: 10%">Tipo Trecho <span v-b-tooltip title="No caso de Rodoviário, exerce o local de coleta, entrega, ou o transporte em si ( Normal )" placement="top">[?]</span></th>
                                                 <th style="width: 20%">Municípios</th>
                                                 <th style="width: 15%">Fornecedor* <span v-b-tooltip title="Fornecedor que irá prestar o serviço do trecho, podendo ser o próprio" placement="top">[?]</span></th>
                                                 <th style="width: 5%">Ações</th>
                                              </tr>
                                              <tr :class="classSubtrecho(row.subtrecho)" style="display: table-row;">
                                                 <td class="p-a-0 m-a-0">
                                                    <b-row class="p-a-0 m-a-0">
                                                       <b-col cols="2" class="p-a-0">
                                                          <b-form-checkbox buttons
                                                                           button-variant="secondary"
                                                                           v-model="row.principal"
                                                                           value="1"
                                                                           unchecked-value="2">
                                                          </b-form-checkbox>
                                                          <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.principal.value')" v-if="form.errors.has('trecho.'+index+'.principal.value')"></b-form-feedback>
                                                       </b-col>
                                                       <b-col cols="10" class="p-a-0">
                                                          <b-form-input type="text"
                                                                         placeholder="Ordem"
                                                                         v-model="row.ordem"
                                                                         >
                                                          </b-form-input>
                                                          <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.ordem')" v-if="form.errors.has('trecho.'+index+'.ordem')"></b-form-feedback>
                                                       </b-col>
                                                   </b-row>
                                                   <b-row class="p-a-0 m-a-0">
                                                       <b-col class="p-a-0">
                                                          <b-form-input type="text"
                                                                       placeholder="% Advalorem"
                                                                       v-model="row.advalorem"
                                                                       >
                                                          </b-form-input>
                                                          <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.advalorem')" v-if="form.errors.has('trecho.'+index+'.advalorem')"></b-form-feedback>
                                                       </b-col>
                                                    </b-row>
                                                 </td>
                                                 <td class="p-a-0">
                                                       <b-col class="p-a-0">
                                                           <multiselect v-model="row.tp_trecho_custo"
                                                           :options="optionsLivTpTrechoCusto"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder=""
                                                           select-label=""
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.tp_trecho_custo.value')" v-if="form.errors.has('trecho.'+index+'.tp_trecho_custo.value')"></b-form-feedback>
                                                       </b-col>
                                                 </td>
                                                 <td class="p-a-0">
                                                    <b-row>
                                                       <b-col class="p-a-0" v-if="row.tp_trecho_custo.value==1">
                                                           <multiselect v-model="row.modal"
                                                           :options="optionsBModal"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder=""
                                                           select-label=""
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.modal.value')" v-if="form.errors.has('trecho.'+index+'.modal.value')"></b-form-feedback>
                                                       </b-col>
                                                    </b-row>
                                                 </td>
                                                 <td class="p-a-0">
                                                     <b-col class="p-a-0" v-if="row.tp_trecho_custo.value==1">
                                                         <multiselect v-model="row.tp_trecho"
                                                         :options="optionsLivTpTrecho"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder=""
                                                         select-label=""
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.tp_trecho.value')" v-if="form.errors.has('trecho.'+index+'.tp_trecho.value')"></b-form-feedback>
                                                     </b-col>
                                                 </td>
                                                <td class="p-a-0">
                                                   <b-row>
                                                       <b-col class="p-a-0">
                                                         <multiselect v-model="row.municipio_ini"
                                                         :options="optionsMunicipioIni"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Inicio"
                                                         tag-placeholder=""
                                                         select-label=""
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.municipio_ini.value')" v-if="form.errors.has('trecho.'+index+'.municipio_ini.value')"></b-form-feedback>
                                                     </b-col>
                                                     <b-col class="p-a-0">
                                                     <span v-if="row.tp_trecho_custo.value==1">
                                                         <multiselect v-model="row.municipio_fim"
                                                         :options="optionsMunicipioFim"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Fim"
                                                         tag-placeholder=""
                                                         select-label=""
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.municipio_fim.value')" v-if="form.errors.has('trecho.'+index+'.municipio_fim.value')"></b-form-feedback>
                                                     </span>
                                                     </b-col>
                                                   </b-row>
                                                </td>
                                                <td class="p-a-0">
                                                 <b-col class="p-a-0">
                                                   <multiselect v-model="row.fornecedor"
                                                   :options-limit="300"
                                                   :limit="2"
                                                   :limit-text="limitText"
                                                   :options="optionsFornecedor"
                                                   track-by="value"
                                                   label="label"
                                                   :hide-selected="true"
                                                   placeholder="Fornecedor ( Digite para pesquisar )"
                                                   tag-placeholder="Selecionar"
                                                   select-label="Selecionar"
                                                   selected-label="Selecionado"
                                                   deselect-label="Remover"
                                                   :searchable="true"
                                                   :loading="isLoadingFor"
                                                   @search-change="listaClientesFornecedor"
                                                   ></multiselect>
                                                   <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.fornecedor.value')" v-if="form.errors.has('trecho.'+index+'.fornecedor.value')"></b-form-feedback>
                                                 </b-col>
                                               </td>
                                               <td align='text-right'>
                                                 <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowTrecho(index);"></i>
                                                 <span v-if="row.modal.cd!=6">
                                                     <i class="fa fa-plus-square" v-on:click="addRowTrechoCusto($event,row,index);" v-b-tooltip.hover.right="'Adicionar Custo'" style="cursor: pointer;"></i>
                                                 </span>
                                                 <span v-if="row.modal.cd==6">
                                                     <i class="fa fa-plus-square-o" v-on:click="addRowSubTrecho($event,row);" v-b-tooltip.hover.right="'Adicionar Subtrecho'" style="cursor: pointer"></i>
                                                 </span>
                                               </td>
                                            </tr>
                                            <tr v-if="row.modal.cd!=6">
                                              <td colspan="8">
                                                <table class="table-striped">
                                                    <tr>
                                                        <th style="width: 30%">Descrição*</th>
                                                        <th style="width: 30%">Tipo Custo*</th>
                                                        <th style="width: 15%">Custo*</th>
                                                        <th style="width: 15%">Valor*</th>
                                                        <th style="width: 10%">Ações</th>
                                                    </tr>
                                                     <tbody>
                                                        <tr v-for="(row2, index2) in row.trecho_custo" style="display: table-row;">
                                                          <td>
                                                            <b-col class="p-a-0">
                                                                <b-form-input type="text"
                                                                            placeholder="Descrição"
                                                                            v-model="row2.descr"
                                                                            >
                                                                </b-form-input>
                                                                <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.descr')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.descr')"></b-form-feedback>
                                                            </b-col>
                                                          </td>
                                                          <td>
                                                            <b-col class="p-a-0">
                                                                <multiselect v-model="row2.tp_custo_trecho"
                                                                :options="optionsLivTpCustoTrecho"
                                                                track-by="value"
                                                                label="label"
                                                                :hide-selected="true"
                                                                placeholder="Selecione"
                                                                tag-placeholder=""
                                                                select-label=""
                                                                selected-label="Selecionado"
                                                                deselect-label="Remover"
                                                                ></multiselect>
                                                                <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.tp_custo_trecho.value')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.tp_custo_trecho.value')"></b-form-feedback>
                                                            </b-col>
                                                          </td>
                                                          <td>
                                                            <b-col class="p-a-0">
                                                                <multiselect v-model="row2.custo"
                                                                :options="optionsCusto"
                                                                track-by="value"
                                                                label="label"
                                                                :hide-selected="true"
                                                                placeholder="Selecione"
                                                                tag-placeholder=""
                                                                select-label=""
                                                                selected-label="Selecionado"
                                                                deselect-label="Remover"
                                                                ></multiselect>
                                                                <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.custo.value')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.custo.value')"></b-form-feedback>
                                                            </b-col>
                                                          </td>
                                                          <td>
                                                            <b-col class="p-a-0">
                                                                <b-form-input type="text"
                                                                            @change="getDespesaCusto(trecho)"
                                                                            placeholder="Valor"
                                                                            v-model="row2.valor"
                                                                            >
                                                                </b-form-input>
                                                                <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.valor')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.valor')"></b-form-feedback>
                                                            </b-col>
                                                          </td>
                                                          <td>
                                                            <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowTrechoCusto(row,index2);"></i>
                                                          </td>
                                                       </tr>
                                                    </tbody>
                                                 </table>
                                              </td>
                                            </tr>

                                            <tr v-if="row.subtrechos.length>=1">
                                                <td>
                                                    <b-row>
                                                        <b-col>
                                                            <label>Valor total*</label>
                                                            <b-form-input type="text"
                                                                        placeholder="Valor"
                                                                        @change="getDespesaCusto"
                                                                        v-model="row.vlr_total_subtrecho"
                                                                        >
                                                            </b-form-input>
                                                            <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.trecho_custo.'+index+'.vlr_total_subtrecho')" v-if="form.errors.has('trecho.trecho_custo.'+index+'.valor')"></b-form-feedback>
                                                        </b-col>
                                                    </b-row>
                                                </td>
                                                <td colspan="8">
                                                    <table class="table-striped">
                                                        <tbody v-for="(row2, index2) in row.subtrechos">
                                                            <tr :class="classSubtrecho(row2.subtrecho)">
                                                                <th style="width: 10%">Ordem*</th>
                                                                <th style="width: 10%">Operação*</th>
                                                                <th style="width: 10%">Modal*</th>
                                                                <th style="width: 20%">Municípios*</th>
                                                                <th style="width: 10%">Descrição*</th>
                                                                <th style="width: 10%">Custo*</th>
                                                                <th style="width: 5%">Ações</th>
                                                            </tr>
                                                            <tr :class="classSubtrecho(row2.subtrecho)" style="display: table-row;">
                                                                <td class="p-a-0 m-a-0">
                                                                    <b-col class="p-a-0">
                                                                        <b-form-input type="text"
                                                                                    placeholder="Ordem"
                                                                                    v-model="row2.ordem"
                                                                                    >
                                                                        </b-form-input>
                                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.ordem')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.ordem')"></b-form-feedback>
                                                                    </b-col>
                                                              </td>
                                                              <td class="p-a-0">
                                                                    <b-col class="p-a-0">
                                                                        <multiselect v-model="row2.tp_trecho_custo"
                                                                        :options="optionsLivTpTrechoCusto"
                                                                        track-by="value"
                                                                        label="label"
                                                                        :hide-selected="true"
                                                                        placeholder="Selecione"
                                                                        tag-placeholder=""
                                                                        select-label=""
                                                                        selected-label="Selecionado"
                                                                        deselect-label="Remover"
                                                                        ></multiselect>
                                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.tp_trecho_custo.value')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.tp_trecho_custo.value')"></b-form-feedback>
                                                                    </b-col>
                                                              </td>
                                                              <td class="p-a-0">
                                                                  <b-col class="p-a-0" v-if="row2.tp_trecho_custo.value==1">
                                                                    <multiselect v-model="row2.modal"
                                                                    :options="optionsBModal"
                                                                    track-by="value"
                                                                    label="label"
                                                                    :hide-selected="true"
                                                                    placeholder="Selecione"
                                                                    tag-placeholder=""
                                                                    select-label=""
                                                                    selected-label="Selecionado"
                                                                    deselect-label="Remover"
                                                                    ></multiselect>
                                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.modal.value')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.modal.value')"></b-form-feedback>
                                                                  </b-col>
                                                              </td>
                                                              <td>
                                                                  <b-row>
                                                                      <b-col class="p-a-0">
                                                                        <multiselect v-model="row2.municipio_ini"
                                                                        :options="optionsMunicipioIni"
                                                                        track-by="value"
                                                                        label="label"
                                                                        :hide-selected="true"
                                                                        placeholder="Inicio"
                                                                        tag-placeholder=""
                                                                        select-label=""
                                                                        selected-label="Selecionado"
                                                                        deselect-label="Remover"
                                                                        ></multiselect>
                                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.municipio_ini.value')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.municipio_ini.value')"></b-form-feedback>
                                                                    </b-col>
                                                                    <b-col class="p-a-0" v-if="row2.tp_trecho_custo.value==1">
                                                                        <span>
                                                                            <multiselect v-model="row2.municipio_fim"
                                                                            :options="optionsMunicipioFim"
                                                                            track-by="value"
                                                                            label="label"
                                                                            :hide-selected="true"
                                                                            placeholder="Fim"
                                                                            tag-placeholder=""
                                                                            select-label=""
                                                                            selected-label="Selecionado"
                                                                            deselect-label="Remover"
                                                                            ></multiselect>
                                                                            <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.municipio_fim.value')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.municipio_fim.value')"></b-form-feedback>
                                                                        </span>
                                                                    </b-col>
                                                                </b-row>
                                                            </td>
                                                            <td>
                                                              <b-col class="p-a-0">
                                                                  <b-form-input type="text"
                                                                              placeholder="Descrição"
                                                                              v-model="row2.descr_custo"
                                                                              >
                                                                  </b-form-input>
                                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.descr')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.descr')"></b-form-feedback>
                                                              </b-col>
                                                            </td>
                                                            <td class="p-a-0">
                                                              <b-col class="p-a-0">
                                                                  <multiselect v-model="row2.custo"
                                                                  :options="optionsCusto"
                                                                  track-by="value"
                                                                  label="label"
                                                                  :hide-selected="true"
                                                                  placeholder="Selecione"
                                                                  tag-placeholder=""
                                                                  select-label=""
                                                                  selected-label="Selecionado"
                                                                  deselect-label="Remover"
                                                                  ></multiselect>
                                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.custo.value')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.custo.value')"></b-form-feedback>
                                                              </b-col>
                                                            </td>
                                                            <td align='text-right'>
                                                                <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowSubTrecho(row, index2);"></i>
                                                            </td>
                                                         </tr>
                                                    </tbody>
                                                </table>
                                              </td>
                                           </tr>
                                        </tbody>
                                    </table>
                                    <table class="table-striped">
                                        <tbody>
                                            <tr class="table-info" style="display: table-row;">
                                                <td colspan="11" style="width: 90%">
                                                </td>
                                                <td class='text-right' style="width: 90%; ">
                                                    <i class="fa fa-plus-square" v-on:click="addRowTrecho($event,2);" v-b-tooltip.hover.right="'Adicionar Trecho'" style="cursor: pointer;"></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-tab>

                                  <b-tab title="Receita - Comp. Frete" >
                                    <table class="table-striped">
                                        <thead>
                                            <tr>
                                                <th style="width: 10%">Insere Advalorem</th>
                                                <th style="width: 40%">Componente*</th>
                                                <th style="width: 40%">Valor*</th>
                                                <th style="width: 10%">Ações</th>
                                            </tr>
                                         </thead>
                                         <tbody>
                                             <tr v-for="(row, index) in comp_frete">
                                               <td>
                                                 <b-col class="p-a-0">
                                                   <b-form-group>
                                                   <b-form-checkbox buttons
                                                                    button-variant="secondary"
                                                                    v-model="row.insere_advalorem.valor"
                                                                    value="1"
                                                                    unchecked-value="2">
                                                   </b-form-checkbox>
                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.insere_advalorem.value')" v-if="form.errors.has('comp_frete.'+index+'.insere_advalorem.value')"></b-form-feedback>
                                                </b-form-group>
                                                 </b-col>
                                               </td>
                                                <td>
                                                    <multiselect v-model="row.custo"
                                                    :options="optionsCustoCFrete"
                                                    track-by="value"
                                                    label="label"
                                                    :hide-selected="true"
                                                    placeholder="Selecione"
                                                    tag-placeholder="Selecionar"
                                                    select-label="Selecionar"
                                                    selected-label="Selecionado"
                                                    deselect-label="Remover"
                                                    ></multiselect>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.custo.value')" v-if="form.errors.has('comp_frete.'+index+'.custo.value')"></b-form-feedback>
                                                </td>
                                                <td>
                                                  <b-col>
                                                      <b-form-input type="text"
                                                                  placeholder="Valor"
                                                                  v-model="row.valor"
                                                                  @change="getReceita"
                                                                  >
                                                      </b-form-input>
                                                      <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.valor')" v-if="form.errors.has('comp_frete.'+index+'.valor')"></b-form-feedback>
                                                  </b-col>
                                                </td>
                                                <td>
                                                    <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowCompFrete(index);"></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <td colspan="3"></td>
                                        <td>
                                          <i class="fa fa-plus-square" v-on:click="addRowCompFrete($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                        </td>
                                    </table>
                                  </b-tab>

                                  <b-tab title="Seguro">
                                    <table class="table-striped">
                                        <thead>
                                            <tr>
                                                <th style="width: 45%">Responsável pelo seguro*</th>
                                                <th style="width: 45%">Seguradora*</th>
                                                <th style="width: 5%">Ações</th>
                                            </tr>
                                         </thead>
                                         <tbody>
                                             <tr v-for="(row, index) in seguro">
                                                <td>
                                                  <b-col>
                                                      <multiselect v-model="row.respseg"
                                                      :options="optionsParamRespSeg"
                                                      track-by="value"
                                                      label="label"
                                                      :hide-selected="true"
                                                      placeholder="Selecione"
                                                      tag-placeholder="Selecionar"
                                                      select-label="Selecionar"
                                                      selected-label="Selecionado"
                                                      deselect-label="Remover"
                                                      ></multiselect>
                                                      <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.respseg.value')" v-if="form.errors.has('seguro.'+index+'.respseg.value')"></b-form-feedback>
                                                  </b-col>
                                                </td>
                                                <td>
                                                  <multiselect v-model="row.seguradora"
                                                  :options="optionsSeguradora"
                                                  track-by="value"
                                                  label="label"
                                                  :hide-selected="true"
                                                  placeholder="Selecione"
                                                  tag-placeholder="Selecionar"
                                                  select-label="Selecionar"
                                                  selected-label="Selecionado"
                                                  deselect-label="Remover"
                                                  ></multiselect>
                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.seguradora.value')" v-if="form.errors.has('seguro.'+index+'.seguradora.value')"></b-form-feedback>
                                                </td>
                                                <td>
                                                    <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowSeguro(index);"></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <td></td><td></td>
                                        <td>
                                          <i class="fa fa-plus-square" v-on:click="addRowSeguro($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                        </td>
                                    </table>
                                  </b-tab>
                                </b-tabs>
                            </b-col>
                        </b-row>
                   </b-container fluid class="p-a-0">
                 </form>
                 <div slot="modal-footer" class="w-100">
                        <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                        <div class="float-right">
                          <div class="float-left" v-if="this.errors_array.length>0">
                          <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

                          <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                            <table class="table-striped" id="mais">
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                        <td>
                                          {{ item.erro }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                          </b-popover>
                        </div>
                        &nbsp;

                            <b-btn @click="showModal=false" variant="secondary">
                              Fechar
                            </b-btn>
                            <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                              Enviar
                            </b-btn>
                        </div>
                 </div>
              </b-modal>
             </div>
</template>
<script>
import moment from 'moment'
import accounting from 'accounting'
import {VMoney} from 'v-money'
import PedidoForm from './PedidoForm'

export default {
    components: {
        PedidoForm,
        VMoney,
    },
    data () {
        return {
          dataExport: [],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          showPopover: false,
          isLoadingTom: false,
          isLoadingFor: false,
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          showModalUc: false,
          showModalDuplicar: false,
          showModalHelp: false,
          optionsLivStatus: [],
          optionsStatus: [],
          optionsCfop: [],
          optionsParamCst: [],
          optionsPedidoTomador: [],
          optionsMunicipioIni: [],
          optionsMunicipioFim: [],
          optionsLivTpPedido: [],
          optionsLivTpServico: [],
          optionsLivTpCarga: [],
          optionsLivTpFronteira: [],
          optionsLivAdvalorem: [],
          optionsLivTpValorAdvalorem: [],
          optionsLivTpValorCarga: [],
          optionsLivAddUc: [],
          optionsLivImpostoIncluso: [],
          optionsTomador: [],
          optionsFornecedor: [],
          optionsLivStatusTrecho: [],
          optionsLivTpTrecho: [],
          optionsLivTpCusto: [],
          optionsBModal: [],
          optionsLivTpTrechoCusto: [],
          optionsLivStatusTrechoCusto: [],
          optionsLivTpCustoTrecho: [],
          optionsCusto: [],
          optionsLivTpCFrete: [],
          optionsCustoCFrete: [],
          optionsParamRespSeg: [],
          optionsSeguradora: [],
          valor_total_custo_trecho: 0,
          valor_total_custo: 0,
          valor_total_despesa: 0,
          valor_total_receita: 0,
          margem: 0,
          errors_array: [],
          trecho: [ { status: 2,
                     tp_trecho: [],
                     tp_custo: 2,
                     modal: [],
                     municipio_ini: [],
                     municipio_fim: [],
                     principal: 2,
                     ordem: '',
                     pedpartre_id: '',
                     fornecedor: [],
                     tp_trecho_custo: [],
                     advalorem: '',
                     vlr_total_subtrecho: 0,
                     subtrecho: 2,
                     subtrechos: [
                                    { status: 2,
                                        tp_trecho: [],
                                        tp_custo: 2,
                                        modal: [],
                                        municipio_ini: [],
                                        municipio_fim: [],
                                        principal: 2,
                                        ordem: '',
                                        pedpartre_id: '',
                                        tp_trecho_custo: [],
                                        subtrecho: 1,
                                        descr_subtrecho: '',
                                        custo_subtrecho: []
                                     }
                                ],
                     trecho_custo: [ { status: 1,
                                    tp_custo_trecho: [],
                                    descr: '',
                                    valor: 0,
                                    pedpartrc_id: '',
                                    custo: []
                                }],
                  }],
         comp_frete: [ {pedparcfr_id: '',
                    valor: 0,
                    insere_advalorem: 2,
                    custo: [],}],
         seguro: [ { respseg: [],
                    seguradora: [],
                    partprese_id: '',}],
         form: new Form({ descr: '',
                           obs: '',
                           obs_cte: '',
                           obs_cte_fiscal: '',
                           dt_pedido: '',
                           percentual_advalorem: 0,
                           produto_predominante: '',
                           pedido_id: '',
                           qtde_uc: 0,
                           bmodal: [],
                           status: [],
                           cfop: [],
                           cst: [],
                           municipio_ini: [],
                           municipio_fim: [],
                           tp_pedido: [],
                           tp_servico: [],
                           tp_carga: [],
                           tp_fronteira: [],
                           exibe_advalorem_cfrete: [],
                           tp_valor_advalorem: [],
                           tp_valor_carga: [],
                           permite_adicionar_uc: [],
                           imposto_incluso: [],
                           tomador: [],
                           pedido_tomador: [],
                           trecho: [],
                           comp_frete: [],
                           valor_total_receita: 0,
                           margem: 0,
                           custo_receita: [],
                           seguro: [],
                       }),
         aliquota: {
             decimal: ',',
             prefix: '% ',
             precision: 2,
             masked: false /* doesn't work with directive */
         },
         helpForm: new Form({statusRecord: [], params: [],search:'', status: ''}),
         fields: [
          {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          },
          {
            name: '__slot:pessoa',
            title: 'CPNJ/Razão Social',
            sortField: 'pessoa'
          },
          {
            name: 'num_pedido',
            title: 'N° Pedido',
            sortField: 'num_pedido'
          },
          {
            name: 'descr',
            title: 'Descrição',
            sortField: 'descr'
          },
          {
            name: 'dt_pedido',
            title: 'Data do Pedido',
            callback: 'formatDate|DD/MM/YYYY'
          },
          {
            name: '__slot:status',
            title: 'Status',
            sortField: 'status'
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
      ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney,
        qtd: VMoney,
        percentual_reducao_bc: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
      },

    methods: {
        classSubtrecho : function(subtrecho){
            if(subtrecho==1)
            {
                return 'table-success';
            }
            else
            {
                return 'table-info';
            }
        },
        onShowHelp() {
            this.modal_titulo = "Ajuda";
            this.modal_acao = "i";
            this.showModalHelp = true;
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
            else
            {
                this.onUpdate(this.form.pedido_id);
            }
        },
        onCreate ()
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar";
          this.modal_botao = "Cadastrar";
          this.modal_acao = "i";
          this.form.reset();
          this.valor_total_despesa = 0;
          this.trecho = '';
          this.trecho = [];
          this.seguro = '';
          this.seguro = [];
          this.comp_frete = '';
          this.comp_frete = [];
          this.errors_array = '';
          this.errors_array = [];
          this.$refs.modal_form.show();
        },
        onEdit (data, index)
        {console.log(data);
            this.isDisabled = false;
            this.loading = false;
            if(index==null)//edit da cotacao
            {
                this.modal_titulo = "Ajustar Pedido";
                this.modal_botao = "Ajustar Pedido";
                this.modal_acao = "i";
            }
            this.form.reset();
            this.errors_array = '';
            this.errors_array = [];
            this.vo_fornecedor = null;
            this.form.descr = data.descr;
            this.form.dt_pedido = this.formatDate(data.dt_pedido);
            this.form.produto_predominante = data.produto_predominante;
            this.form.percentual_advalorem = this.formatNumber(data.percentual_advalorem);
            this.form.obs = data.obs;
            this.form.obs_cte = data.obs_cte;
            this.form.obs_cte_fiscal = data.obs_cte_fiscal;
            this.form.qtde_uc = data.qtde_uc;

            if(data.b_modal!==null)
            {
                this.form.bmodal = { label: data.b_modal.descr, value: data.b_modal.bmodal_id };
            }
            else
            {
                this.form.bmodal = {label: "Selecione"};
            }

            if(data.cfop!==null)
            {
                this.form.cfop = { label: data.cfop.descr, value: data.cfop.cfop_id };
            }
            else
            {
                this.form.cfop = {label: "Selecione"};
            }

            if(data.param_cst!==null)
            {
                this.form.cst = { label: data.param_cst.descr, value: data.param_cst.parcst_id };
            }
            else
            {
                this.form.cst = {label: "Selecione"};
            }

            if(data.pedido_tomador!==null)
            {
                this.form.pedido_tomador = { label: data.pedido_tomador.descr, value: data.pedido_tomador.valor };
            }
            else
            {
                this.form.pedido_tomador = {label: "Selecione"};
            }

            if(data.municipio_inicio!==null)
            {
                this.form.municipio_ini = { label: data.municipio_inicio.nome, value: data.municipio_inicio.municipio_id };
            }
            else
            {
                this.form.municipio_ini = {label: "Selecione"};
            }

            if(data.municipio_fim!==null)
            {
                this.form.municipio_fim = { label: data.municipio_fim.nome, value: data.municipio_fim.municipio_id };
            }
            else
            {
                this.form.municipio_fim = {label: "Selecione"};
            }

            if(data.tp_pedido!==null)
            {
                this.form.tp_pedido = { label: data.tp_pedido.descr, value: data.tp_pedido.valor };
            }
            else
            {
                this.form.tp_pedido = {label: "Selecione"};
            }
            if(data.tp_servico!==null)
            {
                this.form.tp_servico = { label: data.tp_servico.descr, value: data.tp_servico.valor };
            }
            else
            {
                this.form.tp_servico = {label: "Selecione"};
            }
            if(data.tp_carga!==null)
            {
                this.form.tp_carga = { label: data.tp_carga.descr, value: data.tp_carga.valor };
            }
            else
            {
                this.form.tp_carga = {label: "Selecione"};
            }
            if(data.tp_fronteira!==null)
            {
                this.form.tp_fronteira = { label: data.tp_fronteira.descr, value: data.tp_fronteira.valor };
            }
            else
            {
                this.form.tp_fronteira = {label: "Selecione"};
            }
            if(data.exibe_advalorem_cfrete!==null)
            {
                this.form.exibe_advalorem_cfrete = { label: data.exibe_advalorem_cfrete.descr, value: data.exibe_advalorem_cfrete.valor };
            }
            else
            {
                this.form.exibe_advalorem_cfrete = {label: "Selecione"};
            }
            if(data.tp_valor_advalorem!==null)
            {
                this.form.tp_valor_advalorem = { label: data.tp_valor_advalorem.descr, value: data.tp_valor_advalorem.valor };
            }
            else
            {
                this.form.tp_valor_advalorem = {label: "Selecione"};
            }
            if(data.tp_valor_carga!==null)
            {
                this.form.tp_valor_carga = { label: data.tp_valor_carga.descr, value: data.tp_valor_carga.valor };
            }
            else
            {
                this.form.tp_valor_carga = {label: "Selecione"};
            }
            if(data.permite_adicionar_uc!==null)
            {
                this.form.permite_adicionar_uc = { label: data.permite_adicionar_uc.descr, value: data.permite_adicionar_uc.valor };
            }
            else
            {
                this.form.permite_adicionar_uc = {label: "Selecione"};
            }
            if(data.imposto_incluso!==null)
            {
                this.form.imposto_incluso = { label: data.imposto_incluso.descr, value: data.imposto_incluso.valor };
            }
            else
            {
                this.form.imposto_incluso = {label: "Selecione"};
            }

            //if(data.pessoa_tomador.pessoa_juridica!==null)
            //{
            //    this.form.tomador = { label: data.pessoa_tomador.cd+" - "+data.pessoa_tomador.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(data.pessoa_tomador.pessoa_juridica.cnpj_base,data.pessoa_tomador.pessoa_juridica.cnpj_filial,data.pessoa_tomador.pessoa_juridica.cnpj_digito)+" - "+data.pessoa_tomador.pessoa_juridica.inscricao_estadual, value: data.pessoa_tomador.pessoa_juridica.pessoa_id };
            //}
            //else
            //{
            //    this.form.tomador = {label: "Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"};
            //}

console.log(1);
            this.trecho = null;
            this.trecho = [];
            data.pedido_param_trecho.forEach((obj)=>{
                if(obj.fornecedor==null)
                {
                  this.vo_fornecedor = null;
                }
                else
                {
                  this.vo_fornecedor = { label: obj.fornecedor.cd+" - "+obj.fornecedor.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(obj.fornecedor.pessoa_juridica.cnpj_base,obj.fornecedor.pessoa_juridica.cnpj_filial,obj.fornecedor.pessoa_juridica.cnpj_digito)+" - "+obj.fornecedor.pessoa_juridica.inscricao_estadual, value: obj.fornecedor.pessoa_juridica.pessoa_id }
                }
                this.trecho.push({ fornecedor: this.vo_fornecedor
                                 , trecho_custo: []
                                 , pedpartre_id: obj.pedpartre_id
                                 , tp_trecho: {label: obj.tp_trecho.descr, value: obj.tp_trecho.valor}
                                 , tp_trecho_custo: {label: obj.tp_trecho_custo.descr, value: obj.tp_trecho_custo.valor}
                                 , modal: {label: obj.b_modal.descr, value: obj.b_modal.bmodal_id}
                                 , municipio_ini: {label: obj.municipio_inicio.nome, value: obj.municipio_inicio.municipio_id}
                                 , municipio_fim: {label: obj.municipio_fim.nome, value: obj.municipio_fim.municipio_id}
                                 , ordem:obj.ordem
                                 , principal:obj.principal.valor
                                 , advalorem: obj.perc_advalorem
                                 , subtrecho: obj.subtrecho
                                 , subtrechos_tmp: obj.subtrechos
                                 , subtrechos: obj.subtrechos
                                 })
            });
console.log(2);
            this.trecho.forEach((obj)=>{console.log(obj.subtrechos_tmp);
                if(obj.subtrechos_tmp.length>0)
                {
                    var vlr_total_subtrecho = 0;
                    obj.subtrechos_tmp.forEach((obj2)=>{

                        obj2.pedido_param_trecho_custo.forEach((obj3)=>{
                            obj.subtrechos.push({
                                ordem: obj2.ordem,
                                principal: obj2.principal,
                                tp_trecho:  {label: obj2.tp_trecho.descr, value: obj2.tp_trecho.valor},
                                tp_trecho_custo: {label: obj2.tp_trecho_custo.descr, value: obj2.tp_trecho_custo.valor},
                                advalorem: obj2.perc_advalorem,
                                modal: {label: obj2.b_modal.descr, value: obj2.b_modal.bmodal_id},
                                municipio_ini: {label: obj2.municipio_inicio.nome, value: obj2.municipio_inicio.municipio_id},
                                municipio_fim: {label: obj2.municipio_fim.nome, value: obj2.municipio_fim.municipio_id},
                                fornecedor: [],
                                subtrecho: obj2.subtrecho,
                                pedpartrc_id: obj3.pedpartrc_id,
                                custo: {label: obj3.custo.descr, value: obj3.custo.custo_id},
                                valor:obj3.vlr_custo,
                                descr_custo:obj3.descr
                            });
                             vlr_total_subtrecho = parseFloat(vlr_total_subtrecho)+parseFloat(obj3.vlr_custo);
                        });
                    });
                    obj.vlr_total_subtrecho = vlr_total_subtrecho;
                }
            });
console.log(3);
            this.seguro = null;
            this.seguro = [];
            if(data.pedido_param_seguro !== null)
            {
                data.pedido_param_seguro.forEach((obj)=>{
                    this.seguro.push({ respseg: {label: obj.param_tipo_resp_seg.descr, value: obj.param_tipo_resp_seg.cd}, seguradora: {label: obj.seguradora.descr, value: obj.seguradora.cd}, segurado_id: obj.seguradora.segurado_id, nome: obj.seguradora.nome, partprese_id:  obj.param_tipo_resp_seg.partprese_id })
                });
            }

console.log(4);
            this.trecho_custo = null;
            this.trecho_custo = [];
            data.pedido_param_trecho.forEach((obj)=>{
                if(obj.pedido_param_trecho_custo.length>=1)
                {
                    obj.pedido_param_trecho_custo.forEach((obj2)=>
                    {
                        this.trecho.forEach((obj3)=>{
                            if(obj3.pedpartre_id==obj2.pedpartre_id)
                            {
                                // Trecho
                                obj3.trecho_custo.push({pedpartrc_id: obj2.pedpartrc_id, custo: {label: obj2.custo.descr, value: obj2.custo.custo_id}, tp_custo_trecho: {label: obj2.tp_custo.descr, value: obj2.tp_custo.valor}, valor:this.formatNumber(obj2.vlr_custo), descr:obj2.descr })
                            }
                        })
                    })
                }
            });
console.log(5);
            this.comp_frete = null;
            this.comp_frete = [];
            if(data.pedido_param_comp_frete !== null)
            {
                data.pedido_param_comp_frete.forEach((obj)=>{
                    this.comp_frete.push({pedparcfr_id:obj.pedparcfr_id, custo: {label: obj.custo.descr, value: obj.custo.custo_id}, valor:this.formatNumber(obj.vlr), insere_advalorem: obj.insere_advalorem.valor })
                });
            }
            if(data.pedido_param_trecho_receita !== null)
            {
                data.pedido_param_trecho_receita.forEach((obj)=>{
                    obj.pedido_param_trecho_custo.forEach((obj2)=>{
                        this.form.custo_receita = { label: obj2.descr, value: obj2.custo_id };
                    });
                });
            }
            console.log(6);
            if(index!==null)//edit da cotacao
            {
                this.form.pedido_id = data.pedido_id;
                this.form.trecho = this.trecho;
                this.form.comp_frete = this.comp_frete;
                this.form.seguro = this.seguro;
                this.getReceita();
                this.getDespesaCusto();
            }
            this.$refs.modal_form.show();
        },
        onStore()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.dt_pedido = this.formatDateSubmit(this.form.dt_pedido);
            this.form.trecho = this.trecho;
            this.form.comp_frete = this.comp_frete;
            this.form.seguro = this.seguro;
            this.form.post('/api/pedido/store').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {

                new ReturnApi(errors, this)
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
            });
        },
        onUpdate(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.trecho = this.trecho;
            this.form.comp_frete = this.comp_frete;
            this.form.seguro = this.seguro;
            this.form.post('/api/pedido/update/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
              new ReturnApi(errors, this)
              this.errors_array = '';
              this.errors_array = [];
              for(var property in errors)
              {
                if(errors.hasOwnProperty(property))
                {
                   if(typeof(errors[property]) === 'object')
                   {
                   errors[property].forEach((obj)=>{
                      this.errors_array.push({erro: obj});
                   });
                   }
                }
              }
          });
        },
        getDespesaCusto: function() {
          this.valor_total_custo_trecho = 0;
          this.row_vlr_subtrecho = 0;
          this.trecho.forEach((obj)=>
          {
              obj.trecho_custo.forEach((obj2)=>
              {
                  this.row_vlr = obj2.valor.replace( ".", "" );
                  this.row_vlr = this.row_vlr.replace( ",", "." );
                  this.row_vlr = parseFloat( this.row_vlr.replace(/[^0-9.]/g, "") );

                  if(this.row_vlr!="" && !isNaN(this.row_vlr))
                  {
                      this.valor_total_custo_trecho = parseFloat(this.valor_total_custo_trecho)+parseFloat(this.row_vlr);
                  }
              })

              if(obj.vlr_total_subtrecho!==undefined && obj.vlr_total_subtrecho!="0")
              {
                  this.row_vlr_subtrecho = obj.vlr_total_subtrecho.toString().replace( ".", "" );
                  this.row_vlr_subtrecho = this.row_vlr_subtrecho.replace( ",", "." );
                  this.row_vlr_subtrecho = parseFloat( this.row_vlr_subtrecho.replace(/[^0-9.]/g, "") );
              }

              this.valor_total_custo_trecho = parseFloat(this.valor_total_custo_trecho)+parseFloat(this.row_vlr_subtrecho);
          })
          this.valor_total_despesa = this.formatNumber(parseFloat(this.valor_total_custo_trecho));
        },
        getReceita: function() {
          this.valor_total_receita = 0;
          this.comp_frete.forEach((obj)=>
          {
              this.row_vlr = obj.valor.replace( ".", "" );
              this.row_vlr = this.row_vlr.replace( ",", "." );
              this.row_vlr = parseFloat( this.row_vlr.replace(/[^0-9.]/g, "") );

              if(this.row_vlr!="" && !isNaN(this.row_vlr))
              {
                  this.valor_total_receita = parseFloat(this.valor_total_receita)+parseFloat(this.row_vlr);
              }
          });
          this.form.valor_total_receita = this.formatNumber(parseFloat(this.valor_total_receita));
        },
        getMargemCusto: function(valor) {
              this.form.valor_total_receita = Number((parseFloat(this.valor_total_despesa)/Number((1-(parseFloat(valor)/100)))).toFixed(4)).toFixed(2);
        },
        getMargemCustoReverso: function(valor) {
              this.form.margem = Number(100-Number((Number(parseFloat(this.valor_total_despesa)).toFixed(4)/Number(parseFloat(this.form.valor_total_receita)).toFixed(2))*100).toFixed(4)).toFixed(2);
        },
        formatNumberInterno (value) {
            return accounting.formatNumber(value, 2, ',', '.')
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatDate (value, fmt = 'DD MM YYYY') {
            return (value == null)
            ? ''
            : moment(value, 'YYYY/MM/DD').format(fmt)
        },
        formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
            return (value == null || value == "")
            ? ''
            : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
        },
        getLivGeral() {
            this.helpForm.get('/api/pedido/jsonlistGeral').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.param_cst.forEach((obj)=>
                {
                    this.optionsParamCst.push({ label: obj.cd+" - "+obj.descr, value: obj.parcst_id })
                })
                response.seguradora.forEach((obj)=>
                {
                    this.optionsSeguradora.push({ label: obj.nome, value: obj.segurado_id })
                })
                response.param_resp_seg.forEach((obj)=>
                {
                    this.optionsParamRespSeg.push({ label: obj.descr, value: obj.partprese_id })
                })
                response.municipio.forEach((obj)=>
                {
                    this.optionsMunicipioIni.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id })
                    this.optionsMunicipioFim.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id })
                })
                response.cfop.forEach((obj)=>
                {
                    this.optionsCfop.push({ label: obj.cd+" - "+obj.descr, value: obj.cfop_id })
                })
                response.status.forEach((obj)=>
                {
                    this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_pedido.forEach((obj)=>
                {
                    this.optionsLivTpPedido.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_servico.forEach((obj)=>
                {
                    this.optionsLivTpServico.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_carga.forEach((obj)=>
                {
                    this.optionsLivTpCarga.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_fronteira.forEach((obj)=>
                {
                    this.optionsLivTpFronteira.push({ label: obj.descr, value: obj.valor })
                })
                response.exibe_advalorem_cfrete.forEach((obj)=>
                {
                    this.optionsLivAdvalorem.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_valor_advalorem.forEach((obj)=>
                {
                    this.optionsLivTpValorAdvalorem.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_valor_carga.forEach((obj)=>
                {
                    this.optionsLivTpValorCarga.push({ label: obj.descr, value: obj.valor })
                })
                response.permite_adicionar_uc.forEach((obj)=>
                {
                    this.optionsLivAddUc.push({ label: obj.descr, value: obj.valor })
                })
                response.imposto_incluso.forEach((obj)=>
                {
                    this.optionsLivImpostoIncluso.push({ label: obj.descr, value: obj.valor })
                })
                response.status_trecho.forEach((obj)=>
                {
                    this.optionsLivStatusTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.b_modal.forEach((obj)=>
                {
                    this.optionsBModal.push({ label: obj.descr, value: obj.bmodal_id, cd: obj.cd })
                })
                response.tp_trecho.forEach((obj)=>
                {
                    this.optionsLivTpTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_custo.forEach((obj)=>
                {
                    this.optionsLivTpCusto.push({ label: obj.descr, value: obj.valor })
                })
                response.status_trecho_custo.forEach((obj)=>
                {
                    this.optionsLivStatusTrechoCusto.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_custo_trecho.forEach((obj)=>
                {
                    this.optionsLivTpCustoTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.custo.forEach((obj)=>
                {
                    this.optionsCusto.push({ label: obj.descr, value: obj.custo_id })
                })
                response.pedido_tomador.forEach((obj)=>
                {
                    this.optionsPedidoTomador.push({ label: obj.descr, value: obj.valor })
                })
                response.custo.forEach((obj)=>
                {
                    if(obj.is_cfrete==1)
                    {
                        this.optionsCustoCFrete.push({ label: obj.descr, value: obj.custo_id })
                    }
                })
                response.tp_trecho_custo.forEach((obj)=>
                {
                    this.optionsLivTpTrechoCusto.push({ label: obj.descr, value: obj.valor })
                })

            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        listaClientesTomador(search) {
            if(search.length>=3)
            {
                this.isLoadingTom = true;
                this.helpForm.search = search;
                this.helpForm.status = 1;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsTomador = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsTomador.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingTom = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                  });
              }
          },
          listaClientesFornecedor(search) {
              if(search.length>=3)
              {
                  this.isLoadingFor = true;
                  this.helpForm.search = search;
                  this.helpForm.post('/api/pessoa/jsonlist/fornecedor').then(response =>
                  {
                      this.optionsFornecedor = [];
                      new ReturnApi(response, this, true, false, false);
                      response.items.forEach((obj)=>
                      {
                          this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                      });
                      this.isLoadingFor = false;
                  })
                  .catch(errors =>
                  {
                      new ReturnApi(errors, this)
                    });
                }
            },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
            var cnpj_formatado
            var pad = "00000000";
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
            return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
        },
        addRowTrecho: function(e, en_subtrecho) {
            e.preventDefault();
            this.trecho.push({
                ordem: "",
                principal: 2,
                tp_trecho: [],
                tp_trecho_custo: [],
                advalorem: '',
                modal: [],
                municipio_ini: [],
                municipio_fim: [],
                fornecedor: [],
                status: "",
                subtrecho: en_subtrecho,
                tp_custo: "",
                vlr_total_subtrecho: 0,
                trecho_custo: [],
                subtrechos: [],
            });
        },
        addRowSubTrecho: function(e, row) {
            e.preventDefault();
            row.subtrechos.push({
                ordem: "",
                principal: 2,
                tp_trecho: [],
                tp_trecho_custo: [],
                advalorem: '',
                modal: [],
                municipio_ini: [],
                municipio_fim: [],
                fornecedor: [],
                status: "",
                tp_custo: "",
                subtrecho: 1,
            });
        },
        removeRowTrecho: function(index) {
            this.trecho.splice(index, 1);
            this.getDespesaCusto()
        },
        removeRowSubTrecho: function(row, index) {
            row.subtrechos.splice(index, 1);
            if(row.subtrechos.length==0)
            {
                row.vlr_total_subtrecho = 0;
            }
            this.getDespesaCusto();
        },
        addRowTrechoCusto: function(e, row, index) {
            e.preventDefault();
            this.trecho[index].trecho_custo.push({
                valor: "",
                descr: "",
                tp_custo_trecho: [],
                custo: [],
            });
        },
        removeRowTrechoCusto: function(row,index) {
            row.trecho_custo.splice(index, 1);
            this.getDespesaCusto();
        },
        addRowSeguro: function(e) {
            e.preventDefault();
            this.seguro.push({
                seguradora: [],
                respseg: [],
            });
        },
        removeRowSeguro: function(index) {
            this.seguro.splice(index, 1);
        },
        addRowCompFrete: function(e) {
            e.preventDefault();
            this.comp_frete.push({
              valor: "",
              insere_advalorem: 2,
              custo: [],
            });
        },
        removeRowCompFrete: function(index) {
            this.comp_frete.splice(index, 1);
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>
